<template>
  <pre>
    {{this.$t('privacy_policy')}}
  </pre>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
}
</script>
